import { getLocalApi } from "./localApi";
import { ProductDivision } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllProductDivisions() : Promise<ProductDivision[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.get_product_divisions, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch divisions')
}